import { createContext } from 'react';

/**
 * service-by-phone D5: true while the checkout asks for the number to call (none on file, or Change
 * is open). The card form starts its payment only once there is a number, and nothing confirms
 * meanwhile, wallets included; a payment already started is kept. The payment screens provide it
 * around the card form (CardCheckoutPanel reads it).
 */
export const CardPaymentWait = createContext(false);
